import { gql, useMutation } from "@apollo/client";

import { ShareCollectionInput } from "../../../generated/gql/graphql";

const SHARE_COLLECTION = gql`
  mutation ShareCollection($input: ShareCollectionInput!) {
    shareCollection(input: $input)
  }
`;

type ShareCollectionApi = {
  shareCollection(input: ShareCollectionInput): Promise<void>;
};

export default function useShareCollection(): ShareCollectionApi {
  const [shareCollectionMut] =
    useMutation<ShareCollectionInput>(SHARE_COLLECTION);

  async function shareCollection(input: ShareCollectionInput): Promise<void> {
    try {
      await shareCollectionMut({
        variables: {
          input,
        },
      });
    } catch (error) {
      throw new Error(`Failed to share collection ${input.collectionId}`);
    }
  }

  return {
    shareCollection,
  };
}
